// ----------------------------------------------------------------------------
// Snippet: Country Switcher
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_country-switcher.scss';


// -------------------------------------
// Variables
// -------------------------------------

// Selectors
const COUNTRY_SWITCHER        = '.country-switcher';
const COUNTRY_SWITCHER_TOGGLE = '.country-switcher__toggle';
const COUNTRY_SWITCHER_LIST   = '.country-switcher__list';
const COUNTRY_SWITCHER_ITEM   = '.country-switcher__item';

// Classes
const COUNTRY_SWITCHER_CLASS  = 'country-switcher';
const OPEN_CLASS              = 'is-open';


// -------------------------------------
// Helpers
// -------------------------------------

function initCountrySwitcher() {
    const body                  = document.querySelector('body');
    const countrySwitcher       = document.querySelector(COUNTRY_SWITCHER);
    const countrySwitcherToggle = document.querySelector(COUNTRY_SWITCHER_TOGGLE);
    const countrySwitcherList   = document.querySelector(COUNTRY_SWITCHER_LIST);
    const countrySwitcherItems  = document.querySelectorAll(COUNTRY_SWITCHER_ITEM);

    countrySwitcher.info = {
        $toggle: countrySwitcherToggle,
        $list  : countrySwitcherList
    }

    countrySwitcherToggle.info = {
        $list    : countrySwitcherList
    }

    // Close the switcher if clicking outside
    body.addEventListener('click', function(event) {
        if (event.target.closest(COUNTRY_SWITCHER_TOGGLE) === null) {
            closeCountryDropdown(countrySwitcherToggle, countrySwitcherList);
        }
    });

    // Close the switcher when pressing 'Escape'
    countrySwitcher.addEventListener('keydown', handleKeyboard);

    // Open/close the switcher when clicking on the toggle
    countrySwitcherToggle.addEventListener('click', function(event) {
        event.preventDefault();

        const $this               = event.currentTarget;
        const countrySwitcherList = $this.info.$list;

        if ($this.classList.contains(OPEN_CLASS)) {
            closeCountryDropdown($this, countrySwitcherList);
        } else {
            $this.classList.add(OPEN_CLASS);
            countrySwitcherList.classList.add(OPEN_CLASS);
        }
    });

    // Close the switcher when tabbing out
    countrySwitcherItems.forEach(function(item) {
        item.info = {
            $toggle: countrySwitcherToggle,
            $list  : countrySwitcherList
        };

        item.addEventListener('keydown', handleKeyboard);
    });
}

function handleKeyboard(event) {
    const $this  = event.currentTarget;

    if ($this.classList.contains(COUNTRY_SWITCHER_CLASS)) {
        const toggle = $this.info.$toggle;
        const list   = $this.info.$list;

        if (event.key === 'Escape' && toggle.classList.contains(OPEN_CLASS)) {
            closeCountryDropdown(toggle, list);
        }
    } else {
        if (event.key === "Tab") {
            const nextItem  = $this.nextElementSibling;
            const prevItem  = $this.previousElementSibling;
            const parent    = $this.parentNode;
            const firstItem = prevItem === null || (prevItem.classList.contains('is-current') && parent.firstElementChild == prevItem);
            const lastItem  = nextItem === null || (nextItem.classList.contains('is-current') && parent.lastElementChild == nextItem);

            if ((event.shiftKey && firstItem) || lastItem) {
                closeCountryDropdown($this.info.$toggle, $this.info.$list);
            }
        }
    }
}

function closeCountryDropdown(toggle, list) {
    toggle.classList.remove(OPEN_CLASS);
    list.classList.remove(OPEN_CLASS);
}

// -------------------------------------
// Hooks
// -------------------------------------

document.addEventListener('DOMContentLoaded', function() {
    initCountrySwitcher();
});
